<script lang="ts" generics="DataType">
	import { formatCurrency } from "$lib/util/format";
	import type { AddonGroup, ExtraGroup, OptionGroup } from "proto/menu";
	import type { ChangeEventHandler } from "svelte/elements";

  export let name: string;
  export let group: OptionGroup | ExtraGroup | AddonGroup;
  export let allOptions: DataType[];
	export let selected: DataType[] = [];
	export let onChange: ChangeEventHandler<HTMLInputElement> = () => {};
</script>

{#each group.items as item, index}
  <label class="checkbox body-m book m-0">
    <input type=checkbox bind:group={selected} {name} value={allOptions[index]} on:change={onChange} disabled={item.availability?.status === "sold_out"} />
    <span class="icon-check-empty-20"></span>
		<span class="icon-check-on-20"></span>
    <div class="label">
      <div class="flex">
        <div>{item.name}</div><!-- TODO: change this to a slot and allow the host to control the content -->
        {#if item.availability?.status === "sold_out"}
         <div class="bold">SOLD OUT</div>
        {:else}
				  <div class="bold">{formatCurrency(item.price)}</div>
        {/if}
      </div>
    </div>
  </label>
{/each}

<style lang="scss">
	@use 'color';
	input[type=checkbox] {
		display: none;
		& ~ .icon-check-on-20 {
			display: none;
			color: color.$primary-variant;
		}
		&:checked {
			& ~ .icon-check-empty-20 { display: none; }
			& ~ .icon-check-on-20 { display: inline-block; }
		}
	}

	span[class^="icon-"] {
		color: color.$on-background-low-importance;
		position: absolute;
		left: 24px;
		margin-top: 2px;
	}
	.label { margin-left: 32px; }
</style>
